import {setSystemToLowercase} from './shared/serverFunctions';
import Config from './messages';

/**
 * POS Kits
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    'POSKits': {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let uri;
            let queryParams = '?params={}';
            if (params && params.filter && params.filter.filter_by === 'filter_location') {
                uri = localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfosByLocation/' + system + '/' + params.filter.filter_location + queryParams;
            } else if (params && params.filter && params.filter.filter_by === 'filter_dba') {
                uri = localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfosByDba/' + system + '/' + params.filter.filter_dba + queryParams;
            } else if (params && params.filter && params.filter.filter_by === 'filter_district') {
                uri = localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfosByDistrict/' + system + '/' + params.filter.filter_district + queryParams;
            } else if (params && params.filter && params.filter.filter_by === 'filter_kit_id') {
                uri = localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfoByKitId/' + system + '/' + params.filter.filter_kit_id;
            } else {
                uri = localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfosBySystem/' + system;
            }
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'POS Kits',
                'uri': uri
            };
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'POS Kit',
                'uri': localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfoByKitId/' + system + '/' + params.id
            };
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let posKitParams = populatePosKitParams(params, true);
            return {
                'type': 'upsert',
                'data': posKitParams.data,
                'uri': localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/upsertPosKitInfo'
            };
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let posKitParams = populatePosKitParams(params, false);
            return {
                'type': 'upsert',
                'data': posKitParams.data,
                'uri': localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/upsertPosKitInfo'
            };
        }
    },
    'POSKitsByKitId': {
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'POS Kit',
                'uri': localStorage.getItem('server') + '/api/v4/Domain/Manager/AdminDomainManager/posKitInfoByKitId/' + system + '/' + params.kit_id
            };
        }
    }
};

/*
 * Populate values for POS Kits
 */
const populatePosKitParams = (params, is_creating = false) => {
    // Populate the required fields
    if (params.data.location_id) {
        params.data.location_id = params.data.location_id.toString();
    }
    // Set "admin" clientUdt
    const clientUdt = {
        system: localStorage.getItem('system'),
        location: Config.fuse.client.location,
        register: Config.fuse.client.register,
        user: localStorage.getItem('email'),
        device: Config.fuse.client.device,
        version: Config.fuse.admin.version
    };
    if (is_creating) {
        params.data.created_by_client = clientUdt;
    } else {
        params.data.modified_by_client = clientUdt;
    }

    return params;
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "DBAs"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    };
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseKitResourceMap.js